// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Nav Bar
// =====================================================================================================================

// Set up constants
const nav = document.getElementById("main-nav");



// Handle Nav Positioning and State
// ---------------------------------------------------------------------------------------------------------------------
if (nav) {
    window.addEventListener('scroll', function () {
        const scrollPoint = 100; // pixel value after which state change is triggered
        if (this.scrollY > scrollPoint) {
            nav.classList.add('scrolled');
        } else if (this.scrollY <= 0 ) {
            nav.classList.remove('scrolled');
        }
    })


    const auxNav = document.getElementById("aux-nav");
    const adminBar = document.getElementById('wpadminbar'); // WordPress Admin Bar

    function getNavOffset() {
        let adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
        let auxOffset = auxNav.getBoundingClientRect().bottom;

        if (adminBar) {
            if (auxOffset > adminBarHeight) {
                return auxOffset;
            } else {
                return adminBarHeight;
            }
        } else {
            if (auxOffset > 0) {
                return auxOffset;
            } else {
                return 0;
            }
        }
    }

    function setNavOffset() {
        document.documentElement.style.setProperty('--nav-offset', getNavOffset() + "px");
    }

    window.addEventListener('load', setNavOffset);
    document.addEventListener('DOMContentLoaded', setNavOffset, false);
    window.addEventListener('resize', setNavOffset, false);
    window.addEventListener('scroll', setNavOffset, false);
}



// Set the current page as active in the nav
const navLinks = document.querySelectorAll('#aux-nav .nav-link, #main-nav .nav-link');
const currentURL = window.location.pathname;
navLinks.forEach(link => {
    if (link.href.slice(-1) === '#') { return; }
    const linkURL = new URL(link.href).pathname;

    // Compare the slugs (last part of the path)
    const currentSlug = currentURL.split('/').filter(Boolean).pop() || '';
    const linkSlug = linkURL.split('/').filter(Boolean).pop() || '';

    if (currentSlug === linkSlug) {
        link.classList.add('active');
        link.ariaCurrent = 'page';
    }
});



// =====================================================================================================================
// Tabs
// =====================================================================================================================
// Set up the classes and labels for the tabs in Gutenberg
const tabContents = document.querySelectorAll('.tab-content');
const tabAuxContent = document.querySelectorAll('.tab-aux-content');
const tabButtons = document.querySelectorAll('.section-tabs button[data-bs-toggle="tab"]');
tabContents.forEach(tabContent => {
    const tabPanes = tabContent.querySelectorAll('.tab-pane');

    tabPanes.forEach((pane, index) => {
        const controllingTab = document.querySelector(`.section-tabs button[aria-controls~="${pane.id}"]`)
        pane.setAttribute('aria-labelledby', controllingTab.id);
        pane.setAttribute('role', 'tabpanel');
        pane.setAttribute('tabindex', '0');
        pane.classList.add('fade');

        if (index === 0) {
            pane.classList.add('active');
            pane.classList.add('show');
        }
    })
})
tabAuxContent.forEach(tabAuxContent => {
    const tabPanes = tabAuxContent.querySelectorAll('.aux-pane');

    tabPanes.forEach((pane, index) => {
        const controllingTab = document.querySelector(`.section-tabs button[aria-controls~="${pane.id}"]`)
        pane.setAttribute('aria-labelledby', controllingTab.id);

        if (index === 0) {
            pane.classList.add('show');
        }
    })
})
if (tabAuxContent.length > 0) {
    tabButtons.forEach(button => {
        button.addEventListener('shown.bs.tab', (event) => {
            const targetSelector = event.target.getAttribute('data-bs-target');

            let showTab = document.querySelector(`${targetSelector}.aux-pane`);
            let tabs = showTab.parentElement.querySelectorAll('.aux-pane');

            tabs.forEach(tab => {
                tab.classList.remove('show');
            })
            showTab.classList.add('show');
        });
    });
}



// =====================================================================================================================
// Splide
// =====================================================================================================================
import Splide from '@splidejs/splide';

// Scroll List Slider
// ---------------------------------------------------------------------------------------------------------------------
const scrollListSliders = document.querySelectorAll('.scroll-list .splide');
scrollListSliders.forEach((list) => {
    const slider = new Splide(list, {
        mediaQuery: 'min',
        arrows: true,
        pagination: true,
        perPage: 1,
        perMove: 1,
        gap: '2rem',
        breakpoints: {
            992: {
                destroy: true,
            }
        }
    });
    slider.mount()
});



// Tab Slider
// ---------------------------------------------------------------------------------------------------------------------
const tabSliders = document.querySelectorAll('.tab-slider .splide');
tabSliders.forEach(function(slider) {
    const carousel = new Splide(slider, {
        arrows: true,
        pagination: false,
        perPage: 1,
        type: 'loop',
        gap:'2rem',
        mediaQuery: 'min',
        breakpoints: {
            768: {
                gap: '2.5rem',
            },
            992: {
                gap: '3.25rem',
                pagination: true,
            },
        }
    }).mount();

    // Carousel tab buttons
    const tabs = slider.querySelectorAll('.tab-btn');
    const tabNames = slider.querySelectorAll('.tab-name');
    tabs.forEach(function(tab, index){
        if (index === 0) {
            tab.classList.add('active');
            tab.setAttribute('disabled', 'true');
        }
        tab.addEventListener('click', function (){
            carousel.go(index);
        })
    })


    // Carousel move event
    carousel.on('move', (index)=> {
        tabs.forEach(function(tab, tabIndex){
            if (tabIndex !== index) {
                tab.classList.remove('active');
                tab.removeAttribute('disabled');
            } else {
                tab.classList.add('active');
                tab.setAttribute('disabled', 'true');
            }
        })
        tabNames.forEach(function(tab, tabIndex){
            if (tabIndex !== index) {
                tab.classList.remove('active');
            } else {
                tab.classList.add('active');
            }
        })
    })
});



// Timeline
// ---------------------------------------------------------------------------------------------------------------------
let timelines = document.querySelectorAll('.timeline .splide');
timelines.forEach((timeline) => {
    const slider = new Splide(timeline, {
        mediaQuery: 'min',
        type: 'slide',
        arrows: true,
        pagination: false,
        perPage: 1,
        perMove: 1,
        gap: 20,
        padding: { left: 20, right: 20 },
        breakpoints: {
            576: {
                gap: 60,
                padding: { left: 60, right: 60 },
            },
            768: {
                perPage: 2,
                gap: 20,
                padding: { left: 20, right: 20 },
            },
            992: {
                perPage: 3,
            },
            1200: {
                gap: 60,
                padding: { left: 60, right: 60 },
            },
            1460: {
                perPage: 4,
                gap: 40,
                padding: { left: 40, right: 40 },
            },
        }
    });
    slider.mount()
})



// Resources Slider
// ---------------------------------------------------------------------------------------------------------------------
let resourcesSliders = document.querySelectorAll('.resource-slider .splide');
resourcesSliders.forEach( (slider) => {
    const slideCount = slider.querySelectorAll('.slide').length;

    const carousel = new Splide(slider, {
        arrows: slideCount > 1,
        pagination: slideCount > 1,
        drag: slideCount > 1,
        perPage: 1,
        focus  : 0,
        perMove: 1,
        type: 'loop',
        gap:'1.5rem',
        padding: { left: '1px', right: '1px' },
        mediaQuery: 'min',
        breakpoints: {
            768: {
                perPage: 2,
                type: slideCount > 2 ? 'loop' : 'slide',
                arrows: slideCount > 2,
                pagination: slideCount > 2,
                drag: slideCount > 2,
            },
            992: {
                perPage: 3,
                type: slideCount > 3 ? 'loop' : 'slide',
                arrows: slideCount > 3,
                pagination: slideCount > 3,
                drag: slideCount > 3,
            },
            1400: {
                perPage: 4,
                type: slideCount > 4 ? 'loop' : 'slide',
                arrows: slideCount > 4,
                pagination: slideCount > 4,
                drag: slideCount > 4,
            }
        }
    });

    carousel.mount();
})



// Product Slider
// ---------------------------------------------------------------------------------------------------------------------
let productsSliders = document.querySelectorAll('.product-slider .splide');
productsSliders.forEach( (slider) => {
    const slideCount = slider.querySelectorAll('.slide').length;

    let breakpoints = {
        576: {
            perPage: 2,
            gap:'3rem',
        },
        768: {
            perPage: 3,
            gap:'2rem',
        },
        1200: {
            perPage: 4,
            arrows: false,
        },
        1460: {
            gap:'3rem',
        }
    }
    if (slideCount === 3) {
        breakpoints = {
            576: {
                perPage: 2,
                gap:'3rem',
            },
            768: {
                perPage: 3,
                gap:'2rem',
                arrows: false,
            },
            992: {
                perPage: 3,
                gap:'3rem'
            },
            1200: {
                gap:'4rem',
            },
            1460: {
                gap:'5rem',
            }
        }
    } else if (slideCount > 4) {
        breakpoints = {
            576: {
                perPage: 2,
                gap:'3rem',
            },
            768: {
                perPage: 3,
                gap:'2rem',
            },
            1200: {
                perPage: 4,
            },
            1460: {
                gap:'3rem',
            }
        }
    }

    const carousel = new Splide(slider, {
        arrows: true,
        pagination: false,
        perPage: 1,
        perMove: 1,
        type: 'slide',
        gap:'4rem',
        mediaQuery: 'min',
        breakpoints: breakpoints,
    });

    carousel.mount();
})


// Quote Slider
let quoteSliders = document.querySelectorAll('.quote-slider .splide');
quoteSliders.forEach( (slider) => {
    const slideCount = slider.querySelectorAll('.slide').length;

    const carousel = new Splide(slider, {
        arrows: slideCount > 1,
        pagination: false,
        drag: slideCount > 1,
        perPage: 1,
        focus  : 0,
        perMove: 1,
        type: 'loop',
    });

    carousel.mount();
})



// =====================================================================================================================
// GSAP
// =====================================================================================================================
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let matchMedia = gsap.matchMedia();


// Scroll List
// ---------------------------------------------------------------------------------------------------------------------
let scrollList = document.querySelectorAll('.scroll-list');
scrollList.forEach((list) => {
    matchMedia.add("(min-width: 992px)", () => {
        // Scroll Content
        let scrollItems = list.querySelectorAll('.scroll-item');
        scrollItems.forEach((item, index) => {
            if (index === 0) {
                item.classList.add('active');
                ScrollTrigger.create({
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: "active",
                    onLeaveBack: () => {
                        item.classList.add('active');
                    }
                });
            } else if (index === scrollItems.length - 1) {
                ScrollTrigger.create({
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: "active",
                    onLeave: () => {
                        item.classList.add('active');
                    }
                });
            } else {
                ScrollTrigger.create({
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: "active",
                });
            }

        })

        // Pin images
        let scrollImages = list.querySelectorAll('.scroll-item figure')
        scrollImages.forEach((image) => {
            ScrollTrigger.create({
                trigger: image,
                start: "center center",
                pin: true,
                endTrigger: '.scroll-list',
                end: () => '+=' + (list.offsetHeight - image.offsetHeight),
            })
        })
    })
});



// =====================================================================================================================
// Video Steps Block
// =====================================================================================================================
class VideoStepController {
    constructor(blockElement) {
        this.block = blockElement;
        this.currentStep = 0;
        this.stepContent = this.block.querySelectorAll('.step-content');
        this.totalSteps = this.stepContent.length;
        this.isTransitioning = false;

        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        const nextBtn = this.block.querySelector('#nextStep');
        const prevBtn = this.block.querySelector('#prevStep');

        nextBtn.addEventListener('click', () => this.nextStep());
        prevBtn.addEventListener('click', () => this.prevStep());

        // Handle video end events
        const videos = this.block.querySelectorAll('.video-transition');
        videos.forEach(video => {
            video.addEventListener('ended', () => this.onVideoEnd(video));
        });
    }

    nextStep() {
        // Prevent playing if transitioning or on last step
        if (this.isTransitioning || this.currentStep >= this.totalSteps - 1) { return; }

        this.isTransitioning = true;
        this.disableNavigation();


        // Add and Remove classes from step content
        this.stepContent.forEach((step) => {
            step.classList.remove('active', 'previous-step', 'next-step')
            if (parseInt(step.dataset.step) === this.currentStep) {
                step.classList.add('previous-step');
            } else if (parseInt(step.dataset.step) === this.currentStep + 1) {
                step.classList.add('next-step');

                // Add 'active' class to the next step after 0.7 seconds
                setTimeout(() => {step.classList.add('active');}, 700);
            }
        })

        // Check if there's a transition video for current step
        const transitionVideo = this.block.querySelector(`.step-video-wrapper[data-step="${this.currentStep}-video"]`);

        if (transitionVideo) {
            this.playTransitionVideo(transitionVideo);
        } else {
            this.goToNextStep();
        }
    }

    prevStep() {
        if (this.isTransitioning || this.currentStep <= 0) {
            return;
        }

        this.isTransitioning = true;
        this.disableNavigation();

        // Remove the active step content
        this.stepContent.forEach(step => {
            step.classList.remove('active', 'previous-step', 'next-step')
        })

        const currentImage = this.block.querySelector(`.step-image-wrapper[data-step="${this.currentStep}"]`);
        const nextImage = this.block.querySelector(`.step-image-wrapper[data-step="${this.currentStep - 1}"]`);

        // Animate to previous step (no video transition on back)
        this.animateStepChange(this.currentStep - 1, () => {
            this.currentStep--;
            this.updateUI();
            this.isTransitioning = false;
            this.fadeOut(currentImage, () => {
                this.fadeIn(nextImage);
            });
        });
    }

    playTransitionVideo(videoElement) {
        const video = videoElement.querySelector('video');
        const currentImage = this.block.querySelector(`.step-image-wrapper[data-step="${this.currentStep}"]`);

        // Hide current image and show video
        this.fadeOut(currentImage, () => {
            this.fadeIn(videoElement, () => {
                video.currentTime = 0;
                video.play().catch(e => {
                    console.warn('Video autoplay failed:', e);
                    // If autoplay fails, skip to the next step
                    this.onVideoEnd(video);
                });
            });
        });
    }

    onVideoEnd(video) {
        const videoContainer = video.closest('.step-video-wrapper');

        // Hide video and go to next step
        this.fadeOut(videoContainer, () => {
            this.goToNextStep();
        });
    }

    goToNextStep() {
        this.animateStepChange(this.currentStep + 1, () => {
            this.currentStep++;
            this.updateUI();
            this.isTransitioning = false;
        });
    }

    animateStepChange(newStep, callback) {
        const newImage = this.block.querySelector(`.step-image-wrapper[data-step="${newStep}"]`);
        this.fadeIn(newImage, callback);
    }

    fadeOut(element, callback = null) {
        element.classList.remove('active');
        if (callback) callback();
    }

    fadeIn(element, callback = null) {
        element.classList.add('active');
        if (callback) callback();
    }

    updateUI() {
        this.updateNavigationButtons();
        this.updateStepContent();
    }

    updateNavigationButtons() {
        const nextBtn = this.block.querySelector('#nextStep');
        const prevBtn = this.block.querySelector('#prevStep');

        prevBtn.disabled = this.currentStep === 0;
        nextBtn.disabled = this.currentStep >= this.totalSteps - 1;
    }

    updateStepContent() {
        this.stepContent.forEach(step => {
            if (parseInt(step.dataset.step) === this.currentStep) {
                step.classList.add('active');
            }
        })
    }

    disableNavigation() {
        const buttons = this.block.querySelectorAll('.step-navigation button');
        buttons.forEach(btn => btn.disabled = true);
    }

}

// Get Video Step Blocks and Instantiate them
const videoStepBlock = document.querySelectorAll('.video-step');
videoStepBlock.forEach(block => {
    new VideoStepController(block);
})



// =====================================================================================================================
// Email Modals
// =====================================================================================================================

// Injects the resource ID in to the HubSpot form field
const hubspotEmailBtn = document.querySelectorAll('.hubspot-email-btn');
const hubspotEmailModal = document.querySelector('.email-modal');
hubspotEmailBtn.forEach( btn => {
    btn.addEventListener('click', () => {
        const resourceIdField = document.querySelector('#hubspot-email-modal .hs_requested_resource input');
        const resourceNameField = document.querySelector('#hubspot-email-modal .hs_resource_name input');
        const resourceTypeField = document.querySelector('#hubspot-email-modal .hs_resource_type input');
        const hubspotID = btn.dataset.hubspot;
        const resourceName = btn.dataset.resource;
        const resourceType = btn.dataset.filetype;

        if (resourceIdField && hubspotID) {
            resourceIdField.value = hubspotID;
        }
        if (resourceNameField && resourceName) {
            resourceNameField.value = resourceName;
        }
        if (resourceTypeField && resourceType) {
            resourceTypeField.value = resourceType;
        }
    })
})

// Reload the page on modal close
if (hubspotEmailModal) {
    hubspotEmailModal.addEventListener('hidden.bs.modal', event => {
         if (hubspotEmailModal.querySelector('.submitted-message') !== null) {
             window.location.reload();
         }
    })
}



// =====================================================================================================================
// Filters
// =====================================================================================================================
const resourceFilter = document.getElementById('resource-filters');
if (resourceFilter) {
    resourceFilter.addEventListener('submit', () => {
        if (window.location.href.indexOf("/page/") > -1) {
            resourceFilter.action = window.location.origin + '/resources/';
        }
        resourceFilter.submit();
    });
}


const documentFilter = document.getElementById('document-filters');
if (documentFilter) {
    documentFilter.addEventListener('change', () => {
        if (window.location.href.indexOf("/page/") > -1) {
            documentFilter.action = window.location.origin + '/thought-leadership/';
        }
        documentFilter.submit();
    });
}



// =====================================================================================================================
// Video Modals
// =====================================================================================================================
const videoModals = document.querySelectorAll(".video-modal.youtube-modal");
videoModals.forEach( modal => {
    let iframe = modal.querySelector('iframe');

    // Play video in modal open (This can error out if the iframe is slow to load)
    modal.addEventListener('show.bs.modal', function(){
        iframe.contentWindow.postMessage(
            JSON.stringify({event: 'command', func: 'playVideo' }
            ), 'https://www.youtube.com'
        );
    })

    // Pause video on modal close
    modal.addEventListener('hide.bs.modal', function(){
        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'pauseVideo' }
            ), 'https://www.youtube.com'
        );
    })
})

